import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './banner-hero-image-full-with-page-title.component.scss';
var BannerHeroImageFullWithPageTitle = /** @class */ (function (_super) {
    tslib_1.__extends(BannerHeroImageFullWithPageTitle, _super);
    function BannerHeroImageFullWithPageTitle(element) {
        return _super.call(this, element) || this;
    }
    BannerHeroImageFullWithPageTitle.prototype.init = function () {
    };
    BannerHeroImageFullWithPageTitle.prototype.bindEvents = function () {
    };
    return BannerHeroImageFullWithPageTitle;
}(Base));
export { BannerHeroImageFullWithPageTitle };



//////////////////
// WEBPACK FOOTER
// ./components/banner-hero-image-full-with-page-title/banner-hero-image-full-with-page-title.component.ts
// module id = 757
// module chunks = 0